import * as React from 'react';

function SvgProgressDepositPayment(props) {
  return (
    <svg viewBox="0 0 20 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M1.429 0C.639 0 0 .64 0 1.429v12.856c0 .79.64 1.43 1.429 1.43H18.57c.79 0 1.429-.64 1.429-1.43V1.43A1.427 1.427 0 0018.571 0H1.43zm16.428 14.286H2.143a.714.714 0 01-.714-.714V5.739H18.57v7.833c0 .394-.32.714-.714.714zm-16.428-10V2.143c0-.395.32-.714.714-.714h15.714c.395 0 .714.32.714.714v2.143H1.43zm7.142 7.857v-1.429a.714.714 0 00-1.428 0v1.43a.714.714 0 001.428 0zm-2.857 0v-1.429a.714.714 0 00-1.428 0v1.43a.714.714 0 001.428 0z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgProgressDepositPayment;
